import React, { useState } from "react";
import { Auth } from "@aws-amplify/auth";
import ApiService from "../../ApiService";
import { Form, Card, Container, Row, Col } from "react-bootstrap";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import ReassignModal from "../Common/popUpModals/ReassignModal";
import AppointmentReq from "../Common/popUpModals/AppointmentReq";
import SendMessage from "../Common/popUpModals/SendMessage";
import SendResult from "../Common/popUpModals/SendResult";
import CreateChartNotesModal from "../Common/popUpModals/CreateChartNotesModal";
import ERXModal from "../Modal/eRx/ERXModal";
import {isValidValue} from "../../util/common";
import ErxService from "../../service/erxService";

const SelectActions = props => {
  const [action, setAction] = useState("");
  const [reassignModal, setReassignModal] = useState(false);
  const [showAppReqModal, setShowAppReqModal] = useState(false);
  const [showSendMsgModal, setShowSendMsgModal] = useState(false);
  const [showSendResultModal, setShowSendResultModal] = useState(false);
  const [showErxModal, setShowErxModal] = useState(false);
  const [showChartNoteModal, setShowChartNoteModal] = useState(false);

  const [snackOpen, setSnackOpen] = useState(false);
  const [snackText, setSnackText] = useState("");
  const [snackSeverity, setSnackSeverity] = useState("");
  const [eRxid, setERxId] = useState("");
  const [sampleLabelPresignedUrl, setSampleLabelPresignedUrl] = useState(null);
  const [sampleLabelPresignedUrlLastDate, setSampleLabelPresignedUrlLastDate] = useState(null);
  
  const printSampleLabels = async () => {
    console.log("printSampleLabels", props?.kitDetail?.sampleLabelPdfS3Url);

    if (!isValidValue(props?.kitDetail?.sampleLabelPdfS3Url)) {
      handleSnackOpen("Sample label not available", "error");
      setAction("");
      return;
    }

    // Check if presigned url is available and not older than 29 mins
    let url = null;

    if (isValidValue(sampleLabelPresignedUrl) &&
        sampleLabelPresignedUrlLastDate &&
        (new Date() - new Date(sampleLabelPresignedUrlLastDate)) < 29 * 60 * 1000) {
      url = sampleLabelPresignedUrl;
    } else {
      // Get S3 presigned url
      try {
        const resp = await ApiService.getPresignedUrl(props?.kitDetail?.sampleLabelPdfS3Url);
        url = resp?.data?.body?.url;
        setSampleLabelPresignedUrl(url);
        setSampleLabelPresignedUrlLastDate(new Date());
      } catch (error) {
        handleSnackOpen("Failed to get presigned URL", "error");
        setAction("");
        return;
      }
    }

    if (!isValidValue(url)) {
      handleSnackOpen("Sample label not available", "error");
      setAction("");
      return;
    }
    setAction("");
    // Open in new window and show print dialog
    const newWindow = window.open(url, '_blank');

    if (newWindow) {
      // Adding a delay to ensure the new window has enough time to load the content before printing
      setTimeout(() => {
        newWindow.focus(); // Bring the new window to the foreground
        newWindow.print();
      }, 1000); // 1-second delay to ensure content is loaded
    } else {
      handleSnackOpen("Failed to open new window", "error");
    }
  };


  const selectedAction =  action => {
    setAction(action);
    setSnackText("");
    setSnackSeverity("");
    switch (action) {
      case "PrintSampleLabel":
        (async () => {
          await printSampleLabels();
        })();
        break;
      case "ReAssign":
        setReassignModal(true);
        break;
      case "AppointmentReq":
        setShowAppReqModal(true);
        break;
      case "SendMessage":
        setShowSendMsgModal(true);
        break;
      case "SendToPass":
        setShowSendResultModal(true);
        break;
      case "SendPrescription":
        (async () => {
          await handleSendPrescription(null, {
            testResult: props.testResult,
            kitDetail: props.kitDetail,
            user: props.patientDetails
          });
        })();
        break;
      case "createChartNote":
        setShowChartNoteModal(true);
        break;
      default:
        console.warn(`Unknown action: ${action}`);
        break;
    }
  };


  // reassing kit modal close
  const handleReassignKitClose = () => {
    setAction("");
    setReassignModal(false);
  };

  // appointment request modal close

  const closeAppReqModal = () => {
    setAction("");
    setShowAppReqModal(false);
  };

  // send message modal close

  const closeSendMsgModal = () => {
    setAction("");
    setShowSendMsgModal(false);
  };

  // send result modal close

  const closeSendResultModal = () => {
    setAction("");
    setShowSendResultModal(false);
  };

  // send result data

  const SendResultData = (noteType, notes, releaseNote = false) => {
    handleSnackOpen("Draft Saved!", "success");

    // if (!releaseNote) {
    //     async function putTestResultNotes() {
    //         try {
    //             // eslint-disable-next-line no-unused-vars
    //             const putTestResultNotes = await ApiService.putTestResultNotes(props.kitId, {
    //                 "noteType": noteType,
    //                 "notes": notes
    //             });
    //             handleSnackOpen('Draft Saved!', "success")
    //         } catch (err) {
    //             console.error(err);
    //             handleSnackOpen(err.message, "error")
    //         }
    //     }

    //     putTestResultNotes();
    // } else {
    //     async function putTestResultNotes() {
    //         try {
    //             // eslint-disable-next-line no-unused-vars
    //             const putTestResultNotes = await ApiService.putTestResultNotes(props.kitId, {
    //                 "noteType": noteType,
    //                 "notes": notes
    //             });

    //             async function putTestResultNotesRelease() {
    //                 try {
    //                     // eslint-disable-next-line no-unused-vars
    //                     const putTestResultNotesRelease = await ApiService.putTestResultNotesRelease(props.kitId);
    //                     handleSnackOpen('Results Sent!', "success")
    //                 } catch (err) {
    //                     console.error(err);
    //                     handleSnackOpen(err.message, "error")
    //                 }
    //             }

    //             putTestResultNotesRelease();
    //         } catch (err) {
    //             console.error(err);
    //             handleSnackOpen(err.message, "error")
    //         }
    //     }

    //     putTestResultNotes();
    // }
  };
  const handleSendPrescription = async (event, rowData) => {
    const testResult = rowData?.testResult;
    const kitDetail = rowData?.kitDetail;
    const isPendingResult = !testResult;

    console.log("testResult", testResult?.testResultStatus);

    if(isPendingResult){
      console.log("isPendingResult", isPendingResult);
      setSnackOpen(true);
      setSnackSeverity("error");
      setSnackText("You can't send prescription until results are released");
      return;
    }

    if(isValidValue(testResult?.testResultStatus)
        && ["PRE_PROCESS", "PENDING_REVIEW", "NEEDS_CLINICIAN_REVIEW"].includes(testResult?.testResultStatus)) {
      setSnackOpen(true);
      setSnackSeverity("error");
      setSnackText("You can't send prescription until results are released");
      return;
    }
    try {
      const userDetailRes = await ApiService.getPatientDetailByEmail(rowData?.user?.email);
      const userDetail = userDetailRes?.data;
      const photonHealthErxPatientId = userDetailRes?.data?.photonHealthErxPatientId;

      if (!userDetail) {
        setSnackOpen(true);
        setSnackSeverity("error");
        setSnackText("Patient account not found");
        return;
      }

      if (photonHealthErxPatientId) {
        setShowErxModal(true);
        setERxId(photonHealthErxPatientId);
      } else {
        const sexAtBirth = ErxService.determineSexAtBirth(userDetail?.genderAtBirth ?? userDetail?.gender);
        const eRxIdRes = await ApiService.createPatientOnPhoton({
          patientId: userDetail?.subUUID,
          firstName: userDetail?.givenName,
          lastName: userDetail?.familyName,
          dob: userDetail?.birthDate,
          sex: sexAtBirth,
          gender: userDetail?.gender,
          phone: userDetail?.phoneNumber,
          email: userDetail?.email,
          address: {
            name: {
              first: userDetail?.givenName,
              last: userDetail?.familyName
            },
            street1: userDetail?.address?.street_address,
            street2: userDetail?.address?.street_address2,
            postalCode: userDetail?.address?.postal_code,
            country: "USA",
            state: userDetail?.address?.region,
            city: userDetail?.address?.locality
          }
        });
        if (eRxIdRes?.data?.erxPhotonId?.id) {
          setShowErxModal(true);
          setERxId(eRxIdRes?.data?.erxPhotonId?.id);
          ApiService.updatePhotonERxPatientId(userDetail?.subUUID, eRxIdRes?.data?.erxPhotonId?.id)
            .then(() => {
              console.log("Patient details updated successfully");
            })
            .catch(err => {
              console.error("Error in updating patient details", err);
            });
        }
      }
    } catch (err) {
      console.log("err", err);
      setSnackOpen(true);
      setSnackSeverity("error");
      setSnackText(err?.response?.data?.message ?? err?.message);
    }
  };

  // snackbar functions
  const handleSnackOpen = (text, severity) => {
    setSnackSeverity(severity);
    setSnackText(text);
    setSnackOpen(true);
  };

  const handleSnackClose = () => {
    setSnackOpen(false);
  };
  const hideErxModal = (orderCreated = false) => {
    setShowErxModal(false);
    if (orderCreated) {
      setSnackOpen(true);
      setSnackSeverity("success");
      setSnackText("Prescription Sent!");
    }
  };

  //Alert

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  return (
    <>
      <Card className="cardRounded">
        <Card.Header className="cardHeader">Select Action</Card.Header>
        <Card.Body className="cardBody">
          <Form.Group>
            <Form.Select
                id="formSelect"
                value={action}
                onChange={e => {
                  selectedAction(e.target.value);
                }}
            >
              <option selected>Select Action</option>
              <option value={"AppointmentReq"}>1. Appointment Req</option>
              <option value={"CreateChartNote"}>2. Create Chart Note</option>
              <option value={"PrintSampleLabel"}>3. Print Sample Labels</option>
              <option value={"ReAssign"}>4. Re-Asssign</option>
              <option value={"SendToPass"}>5. Send result to PASS</option>
              <option value={"SendPrescription"}>6. Send Prescription</option>
              <option value={"SendMessage"}>7. Send Secure Message</option>

            </Form.Select>
          </Form.Group>
        </Card.Body>
      </Card>

      {/* popupmodals */}
      <CreateChartNotesModal
        show={showChartNoteModal}
        onHide={() => setShowChartNoteModal(false)}
        referenceId={props.kitId}
        patientDetails={props.patientDetails}
        referenceType="KIT"
        fetchChartNotes={() => props.fetchChartNotes()}
      />

      {/* //& Send Prescription Modal */}
      {showErxModal && <ERXModal show={showErxModal} onHide={hideErxModal} eRxid={eRxid} />}

      {/* //& Reassign to Me Modal */}
      {reassignModal && <ReassignModal handleClose={handleReassignKitClose} kit={props.kitId} recordType="LAB_REQUEST" />}
      {/* //& Reassign to Me Modal */}
      <AppointmentReq
        showAppReqModal={showAppReqModal}
        kit={props.kitId}
        closeAppReqModal={closeAppReqModal}
        patient={props.patientDetails}
        clinician={props.clinicianDetails}
      />
      <SendMessage
        showSendMsgModal={showSendMsgModal}
        kit={props.kitId}
        closeSendMsgModal={closeSendMsgModal}
        patient={props.patientDetails}
        clinician={props.clinicianDetails}
      />
      <SendResult
        showSendMsgModal={showSendResultModal}
        kit={props.kitId}
        closeSendMsgModal={closeSendResultModal}
        patient={props.patientDetails}
        clinician={props.clinicianDetails}
      />

      {/* snack bar */}

      <Snackbar open={snackOpen} autoHideDuration={6000} onClose={handleSnackClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert onClose={handleSnackClose} severity={snackSeverity}>
          {snackText}
        </Alert>
      </Snackbar>
    </>
  );
};

export default SelectActions;
